import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../data/content";

export default function FAQ({ heading = "Frequently asked questions." }) {
  return (
    <section data-testid="faq-section" className="py-20 md:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="mb-12">
          <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-ink-muted mb-5">
            FAQ
          </div>
          <h2 className="font-display text-3xl md:text-5xl text-ink leading-tight tracking-[-0.03em]">
            {heading}
          </h2>
        </div>
        <Accordion
          type="single"
          collapsible
          className="border-t border-ink-line"
          data-testid="faq-accordion"
        >
          {FAQS.map((f, idx) => (
            <AccordionItem
              key={idx}
              value={`item-${idx}`}
              className="border-b border-ink-line"
              data-testid={`faq-item-${idx}`}
            >
              <AccordionTrigger className="font-display text-base md:text-lg text-ink hover:no-underline py-5 text-left [&[data-state=open]]:text-ink">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-ink-mid text-sm md:text-base leading-relaxed pb-6 pr-8">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
